(() => {
  document.documentElement.classList.add('earthycove-core-ready');

  const assetUrl = (filename) => {
    const script = document.currentScript || Array.from(document.scripts).find((item) => item.src.includes('earthycove-core.js'));
    if (!script || !script.src) return '';

    return script.src.replace(/earthycove-core\.js(?:\?.*)?$/, filename);
  };

  const hydrateBrandAssets = () => {
    const logo = assetUrl('earthycove-logo.svg');
    const favicon = assetUrl('earthycove-favicon.svg');

    if (favicon && !document.querySelector('link[href*="earthycove-favicon.svg"]')) {
      const icon = document.createElement('link');
      icon.rel = 'icon';
      icon.type = 'image/svg+xml';
      icon.href = favicon;
      document.head.appendChild(icon);
    }

    const logoLink = document.querySelector('.header__logo a');
    if (!logoLink || logoLink.querySelector('img') || !logo) return;

    logoLink.classList.remove('header__logo--text');
    logoLink.classList.add('header__logo--image', 'header__logo--earthycove');
    logoLink.textContent = '';

    const mobile = document.createElement('img');
    mobile.src = logo;
    mobile.loading = 'eager';
    mobile.width = 560;
    mobile.height = 132;
    mobile.alt = 'Earthy Cove';
    mobile.className = 'logo header__logo--mobile md:hidden';

    const desktop = document.createElement('img');
    desktop.src = logo;
    desktop.loading = 'eager';
    desktop.width = 560;
    desktop.height = 132;
    desktop.alt = 'Earthy Cove';
    desktop.className = 'logo header__logo--desktop md:block hidden';

    logoLink.append(mobile, desktop);
  };

  const normalizeLogoHeading = () => {
    document.querySelectorAll('h1.header__logo').forEach((heading) => {
      const wrapper = document.createElement('div');
      Array.from(heading.attributes).forEach((attribute) => {
        wrapper.setAttribute(attribute.name, attribute.value);
      });
      wrapper.append(...Array.from(heading.childNodes));
      heading.replaceWith(wrapper);
    });
  };

  const normalizeHeaderAndFooterMenus = () => {
    document.querySelectorAll('.topbar__left, .topbar__right').forEach((column) => {
      column.remove();
    });

    document.querySelectorAll('.topbar__center .topbar__text p').forEach((item) => {
      item.textContent = 'Curated home goods. Secure checkout. Free shipping on orders $69+.';
    });

    const footer = document.querySelector('.footer');
    if (!footer) return;

    footer.querySelectorAll('.footer-block--menu').forEach((block, index, blocks) => {
      const signature = Array.from(block.querySelectorAll('a'))
        .map((link) => `${link.textContent.trim()}|${link.getAttribute('href')}`)
        .join('::');
      const duplicate = Array.from(blocks).slice(0, index).some((previous) =>
        Array.from(previous.querySelectorAll('a'))
          .map((link) => `${link.textContent.trim()}|${link.getAttribute('href')}`)
          .join('::') === signature
      );

      if (signature && duplicate) block.remove();
    });
  };

  const bindMenuDrawerFocus = () => {
    const menuDrawer = document.getElementById('MenuDrawer');
    if (!menuDrawer || menuDrawer.dataset.ecFocusBound === 'true') return;

    menuDrawer.dataset.ecFocusBound = 'true';

    const firstVisibleFocusable = () => {
      const candidates = menuDrawer.querySelectorAll(
        '.menu-drawer__item-link, summary, button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      return Array.from(candidates).find((element) => {
        const box = element.getBoundingClientRect();
        const styles = window.getComputedStyle(element);
        return box.width > 0 && box.height > 0 && styles.visibility !== 'hidden' && styles.display !== 'none';
      });
    };

    const focusMenuStart = () => {
      if (menuDrawer.hidden || !menuDrawer.hasAttribute('open')) return;

      const focusable = firstVisibleFocusable();
      if (focusable && !menuDrawer.contains(document.activeElement)) {
        focusable.focus({ preventScroll: true });
      }
    };

    document.addEventListener('menu-drawer:open', () => {
      window.setTimeout(focusMenuStart, 140);
      window.setTimeout(focusMenuStart, 360);
    });
  };

  const init = () => {
    normalizeLogoHeading();
    hydrateBrandAssets();
    normalizeHeaderAndFooterMenus();
    bindMenuDrawerFocus();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();


/* cro-qty-tier-sync (CRO 2026-10-14, R-20261014-45): when the shopper changes the product quantity (stepper or typing) to 1-3,
   select the matching Vitals volume tier so the highlighted deal matches the quantity. Qty > tiers: no change.
   Functional only: no DOM/style changes, no network calls, no tracking calls. Vitals ignores bare .click(), so a pointer/mouse sequence is used. */
(function () {
  var busy = false;
  function cards() { return Array.prototype.slice.call(document.querySelectorAll('.Vtl-VolumeDiscountCards__TierItem')); }
  function selIdx(c) { for (var i = 0; i < c.length; i++) { if (c[i].className.indexOf('NotSelected') < 0) return i; } return -1; }
  function press(el) {
    var r = el.getBoundingClientRect(), o = { bubbles: true, cancelable: true, composed: true, clientX: r.x + 5, clientY: r.y + 5, pointerId: 1, isPrimary: true, button: 0 };
    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (t) {
      var E = t.indexOf('pointer') === 0 && window.PointerEvent ? PointerEvent : MouseEvent;
      el.dispatchEvent(new E(t, o));
    });
  }
  function sync(input) {
    if (busy) return;
    var q = parseInt(input.value, 10), c = cards();
    if (!c.length || !(q >= 1 && q <= c.length)) return;
    if (selIdx(c) === q - 1) return;
    busy = true;
    press(c[q - 1].querySelector('[class*=TierContent]') || c[q - 1]);
    setTimeout(function () {
      busy = false;
      if (String(input.value) !== String(q)) { input.value = q; input.dispatchEvent(new Event('change', { bubbles: true })); }
    }, 300);
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'quantity' && t.closest && t.closest('form[action*="/cart/add"]')) sync(t);
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('quantity-input button, .quantity__button');
    if (!b) return;
    setTimeout(function () {
      var w = b.closest('quantity-input, .quantity'), i = w && w.querySelector('input[name=quantity]');
      if (i) sync(i);
    }, 120);
  }, true);
})();
